import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ParticipantNavLinks } from './participant-nav-links';
import * as programEnrollmentActions from '../programs/program-permissions.actions';
import { features, featureHelpers } from '../features';
import { integrationTypes, tenantHelpers } from '../tenantInfo';
import './nav.scss';

/** navigation menu for mobile sized screens. Only shows if the screen width is less than  */
export class MobileNav extends Component {

  render() {
    const { auth, programEnrollment, programEnrollmentActions, layout } = this.props;
    const { navbarCollapsed } = layout || {};

    if ( !featureHelpers.featureEnabled(features.apricotPortalTier2) && tenantHelpers.getIntegrationType() == integrationTypes.apricot) {
      return null;
    }

    return (
      <nav id="mobile-sidenav" aria-label="Navigation" data-hidden={navbarCollapsed}>
        <ParticipantNavLinks auth={auth} programEnrollment={programEnrollment} programEnrollmentActions={programEnrollmentActions} />
      </nav>
    );
  }
}

MobileNav.propTypes = {
};

const mapStateToProps = ({ auth, routing, programEnrollment, layout }) => {
  return {
    auth,
    programEnrollment,
    routing,
    layout,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    programEnrollmentActions: bindActionCreators(programEnrollmentActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileNav);



// WEBPACK FOOTER //
// src/layout/mobile-nav.js